{
  "helloWorld": "Hej, världen!",
  "clickMe": "Klicka här",
  "healthCheckFailed": "Hälsokontrollen misslyckades",
  "errors": {
    "unexpected": "Ett oväntat fel uppstod"
  },
  "error": {
    "title": "Något gick fel",
    "description": "Ett oväntat fel uppstod. Du kan försöka igen eller gå tillbaka till startsidan.",
    "tryAgain": "Försök igen",
    "goHome": "Gå till startsidan"
  },
  "dev": {
    "errorPreview": "Felförhandsvisning"
  },
  "actions": {
    "label": "Åtgärder",
    "edit": "Redigera",
    "delete": "Ta bort",
    "save": "Spara",
    "cancel": "Avbryt",
    "expand": "Expandera",
    "collapse": "Minimera"
  },
  "validation": {
    "tooLong": "Får vara max {{max}} tecken",
    "tooShort": "Obligatoriskt",
    "invalidFormat": "Ogiltigt format",
    "invalid": "Ogiltigt värde"
  },
  "nav": {
    "workspace": "Arbetsyta",
    "controlCenter": "Kontrollcenter",
    "jobs": "Jobb",
    "analytics": "Analys",
    "company": "Företag",
    "agentCommunications": "Agentkommunikation",
    "integrations": "Integrationer",
    "suggestedCandidates": "Föreslagna kandidater",
    "unsolicitedApplications": "Spontanansökningar",
    "team": "Team",
    "templates": "Mallar",
    "workflow": "Arbetsflöde",
    "settings": "Inställningar",
    "language": "Språk",
    "help": "Hjälp",
    "logout": "Logga ut",
    "administration": "Administration",
    "adminTenant": "Klientinställningar",
    "adminOrganizations": "Organisationer",
    "adminDepartments": "Avdelningar",
    "adminFeedback": "Feedback",
    "openMenu": "Öppna meny",
    "mcp": "MCP",
    "orgSettings": "Organisationsinställningar"
  },
  "admin": {
    "tenants": {
      "title": "Klienter",
      "newTenant": "Ny klient",
      "columns": {
        "name": "Namn",
        "createdAt": "Skapad",
        "actions": "Åtgärder"
      },
      "createDialog": {
        "title": "Skapa klient",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Redigera klient"
      }
    },
    "tenant": {
      "title": "Klientinställningar",
      "name": "Klientnamn",
      "save": "Spara ändringar",
      "saved": "Sparat"
    },
    "organizations": {
      "title": "Organisationer",
      "newOrg": "Ny organisation",
      "columns": {
        "name": "Namn",
        "slug": "Slug",
        "tenant": "Klient",
        "createdAt": "Skapad",
        "actions": "Åtgärder",
        "viewWorkspace": "Visa arbetsyta"
      },
      "createDialog": {
        "title": "Skapa organisation",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "Ny klient",
        "existingTenant": "Befintlig klient",
        "tenantName": "Klientnamn",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Välj klient"
      },
      "editDialog": {
        "title": "Redigera organisation",
        "language": "Språk",
        "languagePlaceholder": "Välj språk"
      },
      "deleteConfirm": {
        "title": "Ta bort organisation",
        "description": "Detta tar även bort alla avdelningar i denna organisation. Åtgärden kan inte ångras.",
        "confirm": "Ta bort",
        "cancel": "Avbryt"
      }
    },
    "departments": {
      "title": "Avdelningar",
      "newDept": "Ny avdelning",
      "columns": {
        "name": "Namn",
        "slug": "Slug",
        "createdAt": "Skapad",
        "actions": "Åtgärder"
      },
      "createDialog": {
        "title": "Skapa avdelning",
        "namePlaceholder": "Teknik",
        "slugPlaceholder": "teknik"
      },
      "editDialog": {
        "title": "Redigera avdelning"
      },
      "deleteConfirm": {
        "title": "Ta bort avdelning",
        "description": "Åtgärden kan inte ångras.",
        "confirm": "Ta bort",
        "cancel": "Avbryt"
      }
    },
    "viewingOrg": {
      "banner": "Visar: {{name}}",
      "leave": "Lämna"
    },
    "feedback": {
      "title": "Feedback",
      "columns": {
        "rating": "Betyg",
        "modality": "Typ",
        "candidate": "Kandidat",
        "job": "Jobb",
        "org": "Organisation",
        "notes": "Anteckningar",
        "date": "Datum"
      },
      "modality": {
        "voice": "Röst",
        "text": "Chatt"
      },
      "thumbs": {
        "up": "Positivt",
        "down": "Negativt"
      },
      "filter": {
        "all": "Alla",
        "up": "Positivt",
        "down": "Negativt",
        "hasNotes": "Har anteckningar"
      },
      "stats": {
        "title": "Andel negativa",
        "period": "Senaste 7 dagarna",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Ingen förändring",
        "wowNoPrev": "Ingen tidigare data",
        "noData": "Ingen data"
      },
      "noFeedback": "Ingen feedback ännu",
      "noNotes": "Ingen skriftlig kommentar"
    }
  },
  "team": {
    "title": "Team",
    "invite": "Bjud in kollegor",
    "search": "Sök efter namn, e-post, avdelning...",
    "department": "Avdelning",
    "roles": {
      "admin": "Admin",
      "org_manager": "Organisationschef",
      "dept_manager": "Avdelningschef",
      "user": "Användare"
    },
    "columns": {
      "name": "Namn",
      "email": "E-post",
      "role": "Roll",
      "actions": "Åtgärder"
    },
    "inviteDialog": {
      "title": "Bjud in kollega",
      "name": "Namn",
      "namePlaceholder": "Anna Svensson",
      "email": "E-postadress",
      "emailPlaceholder": "kollega@foretag.se",
      "role": "Roll",
      "departments": "Avdelningar",
      "submit": "Skicka inbjudan"
    },
    "actions": {
      "changeRole": "Ändra roll",
      "addDepartment": "Lägg till i avdelning",
      "removeDepartment": "Ta bort från avdelning",
      "removeFromOrg": "Ta bort från organisation"
    },
    "noResults": "Inga resultat hittades.",
    "noMembers": "Inga teammedlemmar ännu."
  },
  "jobs": {
    "title": "Jobb",
    "backToJobs": "Jobb",
    "newJob": "Nytt jobb",
    "createNewJob": "Skapa nytt jobb",
    "importFromAts": "Importera från {{atsName}}",
    "searchPlaceholder": "Sök jobb...",
    "completedPlaceholder": "{{completed}} av {{total}} slutförda",
    "tabs": {
      "active": "Aktiva",
      "archived": "Arkiverade"
    },
    "columns": {
      "name": "Namn",
      "createdBy": "Skapad av",
      "createdAt": "Skapad",
      "actions": "Åtgärder"
    },
    "empty": "Inga jobb hittades.",
    "emptyTitle": "Inga jobb ännu",
    "emptyDescription": "Skapa ditt första jobb eller importera från ditt ATS för att komma igång.",
    "emptyArchivedTitle": "Inga arkiverade jobb",
    "emptyArchivedDescription": "Arkiverade jobb visas här.",
    "emptySearchDescription": "Inga jobb matchar din sökning.",
    "actions": {
      "archive": "Arkivera",
      "archiveConfirmTitle": "Arkivera jobb",
      "archiveConfirmDescription": "Är du säker på att du vill arkivera detta jobb? Det flyttas till fliken Arkiverade.",
      "archiveSuccess": "Jobb arkiverat",
      "archiveError": "Kunde inte arkivera jobb. Försök igen."
    },
    "createError": "Kunde inte skapa jobb. Försök igen.",
    "status": {
      "active": "Aktiv",
      "archived": "Arkiverad"
    },
    "setupStatus": {
      "draft": "Utkast",
      "questions_pending": "Konfiguration behövs",
      "ready": "Klar",
      "active": "Aktiv"
    },
    "applicantSync": {
      "syncingBanner": "Hämtar kandidater från {{provider}}...",
      "failedBanner": "Kandidatsynkronisering misslyckades",
      "adminActions": "Administratörsåtgärder",
      "resyncLabel": "Synkronisera sökande nu",
      "lastSyncedAt": "Senast synkroniserad: {{date}}",
      "addDemoApplicant": "Lägg till demosökande"
    },
    "detail": {
      "tabs": {
        "candidates": "Kandidater",
        "results": "Resultat",
        "settings": "Inställningar"
      },
      "info": {
        "title": "Jobbinformation",
        "employer": "Arbetsgivare",
        "location": "Plats",
        "description": "Beskrivning",
        "modality": "Intervjuformat",
        "languages": "Språk",
        "atsProvider": "ATS-leverantör",
        "atsId": "ATS Jobb-ID",
        "noDescription": "Ingen beskrivning angiven."
      },
      "questions": {
        "title": "Intervjufrågor",
        "empty": "Inga frågor konfigurerade för detta jobb.",
        "optional": "Valfri",
        "categories": {
          "eligibility": "Behörighet",
          "nice_to_have": "Meriterande",
          "job_preview": "Jobbförväntningar",
          "assessment": "Bedömning",
          "information": "Information"
        }
      }
    }
  },
  "wizard": {
    "step": "Steg {{current}} av {{total}}",
    "back": "Tillbaka",
    "next": "Fortsätt",
    "goLive": "Aktivera",
    "saveAndContinue": "Spara & fortsätt",
    "manual": {
      "title": "Nytt jobb",
      "step1Title": "Grundinfo",
      "step2Title": "Intervjufrågor",
      "step3Title": "Bekräfta & aktivera"
    },
    "import": {
      "title": "Importera från ATS",
      "step0Title": "Välj jobb",
      "step1Title": "Koppla steg",
      "step2Title": "Intervjuinställningar",
      "step3Title": "Intervjufrågor",
      "step4Title": "Bekräfta & aktivera"
    },
    "stageSelector": {
      "title": "Koppla pipelinesteg",
      "description": "Välj vilket steg i varje jobb som motsvarar varje Kiku-åtgärd. Förifyllt där stegnamn matchade dina standardinställningar.",
      "continue": "Fortsätt",
      "loading": "Laddar steg…"
    },
    "basicInfo": {
      "title": "Jobbtitel",
      "titlePlaceholder": "t.ex. Senior Mjukvaruutvecklare",
      "description": "Jobbeskrivning",
      "descriptionPlaceholder": "Beskriv rollen, ansvarsområden och krav...",
      "descriptionHint": "Används av AI för att generera relevanta intervjufrågor",
      "employer": "Arbetsgivare (valfritt)",
      "employerPlaceholder": "t.ex. Acme Corp",
      "modality": "Intervjuformat",
      "modalityText": "Textchatt",
      "modalityTextDesc": "Kandidaten skriver svar i ett chattgränssnitt",
      "modalityVoice": "Röstintervju",
      "modalityVoiceDesc": "Liveintervju med ljud i ett virtuellt mötesrum",
      "languages": "Intervjuspråk",
      "languagesHint": "Välj minst ett språk",
      "languagesSearch": "Sök språk…",
      "languagesEmpty": "Inget språk hittades.",
      "modalityRequired": "Välj minst ett intervjuformat",
      "languagesRequired": "Välj minst ett språk"
    },
    "atsSelector": {
      "title": "Välj jobb att importera",
      "search": "Sök jobb...",
      "selectAll": "Välj alla",
      "selected": "{{count}} valda",
      "noJobs": "Inga aktiva jobb hittades i ditt ATS",
      "noDescription": "Ingen beskrivning tillgänglig — AI genererar enbart från titel",
      "continue": "Fortsätt med {{count}} jobb"
    },
    "sharedSettings": {
      "title": "Intervjuinställningar",
      "subtitle": "Dessa inställningar gäller för alla importerade jobb",
      "employer": "Arbetsgivarens namn",
      "employerPlaceholder": "t.ex. Acme Corp"
    },
    "questions": {
      "title": "Intervjufrågor",
      "generateError": "Kunde inte generera frågor. Försök igen.",
      "retry": "Försök igen",
      "generating": "Förbereder frågor för att hitta de bästa kandidaterna…",
      "generatingHint": "Det tar vanligtvis några sekunder",
      "addQuestion": "Lägg till fråga",
      "categories": {
        "eligibility": "Behörighet",
        "nice_to_have": "Meriterande",
        "job_preview": "Realistisk jobbförhandsvisning",
        "assessment": "Bedömning",
        "information": "Informationsinsamling"
      },
      "categoryDescriptions": {
        "eligibility": "Ja/nej-frågor om hårda krav",
        "nice_to_have": "Ja/nej-frågor om önskvärda men ej nödvändiga kvalifikationer",
        "job_preview": "Belyser en utmanande aspekt av rollen. Hjälper till att säkerställa att kandidaten förstår vad rollen innebär och förhindrar avhopp längre fram",
        "assessment": "Beteende- och kompetensbaserade frågor",
        "information": "Frågor för att samla kontext — används inte vid poängsättning"
      },
      "categoryPurpose": {
        "eligibility": "Godkänd eller underkänd",
        "job_preview": "Godkänd eller underkänd",

        "assessment": "Poängsatt",
        "information": "Enbart för information"
      },
      "optional": "Valfri",
      "competency": "Kompetens",
      "scoringExamples": "Bedömningsankare",
      "editScoringExamples": "Redigera bedömningsankare",
      "regenerateScoringExamples": "Generera om bedömningsankare",
      "dontRegenerateScoringExamples": "Generera inte om bedömningsankare",
      "regeneratingScoringExamples": "Genererar om...",
      "regenerateScoringError": "Kunde inte generera om bedömningsankare",
      "score1": "Poäng 1 — Svag",
      "score3": "Poäng 3 — Tillräcklig",
      "score5": "Poäng 5 — Utmärkt",
      "aiGenerated": "AI-genererad"
    },
    "confirm": {
      "title": "Redo att aktivera",
      "jobsCount": "{{count}} jobb kommer att aktiveras",
      "questionsCount": "{{count}} intervjufråga/-or",
      "modality": "Format",
      "languages": "Språk",
      "goLiveHint": "Kandidater kan påbörja intervjuer direkt efter aktivering."
    }
  },
  "login": {
    "title": "Logga in på Kiku",
    "subtitle": "Hantera din rekryteringspipeline.",
    "cta": "Logga in",
    "waitingForLogin": "Väntar på inloggning…",
    "disclosure": "Du interagerar med ett AI-system. Kiku använder AI för att hjälpa till med rekrytering — alla beslut granskas av en människa.",
    "errors": {
      "not_provisioned": "Ditt konto är inte konfigurerat ännu. Kontakta din administratör.",
      "missing_code": "Autentiseringen misslyckades. Försök igen.",
      "session_expired": "Din session har löpt ut. Logga in igen."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Namn",
      "email": "E-post",
      "role": "Roll",
      "departments": "Avdelningar"
    }
  },
  "integrations": {
    "title": "Integrationer",
    "ats": {
      "title": "ATS-anslutning",
      "description": "Anslut ditt ATS för att synkronisera jobb och hantera kandidatsteg.",
      "provider": "Leverantör",
      "apiKey": "API-nyckel",
      "apiKeyPlaceholder": "Ange din API-nyckel",
      "apiKeySet": "Nyckel sparad — ange ett nytt värde för att ersätta den",
      "save": "Spara anslutning",
      "verify": "Verifiera anslutning",
      "verifyStatus": {
        "valid": "Ansluten",
        "invalid": "Ogiltig nyckel",
        "error": "Verifiering misslyckades",
        "idle": "Ej verifierad",
        "loading": "Verifierar..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor är en rekryteringsplattform som hjälper företag att attrahera, vårda och anställa toppkandidater.",
        "recmanDescription": "RecMan är ett rekryteringssystem för bemannings- och rekryteringsbyråer på den nordiska marknaden.",
        "logicmelonDescription": "LogicMelon är ett multi-postnings-ATS för högvolymrekrytering, populärt inom den brittiska utbildningssektorn."
      }
    },
    "stageMapping": {
      "title": "Stegkoppling",
      "description": "Koppla dina ATS-steg till Kiku-arbetsflödessteg.",
      "initialStage": "Initialt steg",
      "passInterviewStage": "Godkänd intervju",
      "failInterviewStage": "Underkänd intervju",
      "recommendedStage": "Rekommenderad",
      "selectStage": "Välj ett steg",
      "save": "Spara koppling"
    },
    "errors": {
      "notConfigured": "Inget ATS konfigurerat. Spara din anslutning först.",
      "fetchStagesFailed": "Kunde inte hämta steg från ditt ATS.",
      "saveFailed": "Kunde inte spara konfigurationen."
    }
  },
  "applications": {
    "title": "Ansökningar",
    "newCandidate": "Ny kandidat",
    "addCandidate": "Lägg till ny kandidat",
    "importFromCsv": "Importera från CSV",
    "importDialog": {
      "title": "Importera kandidater",
      "back": "Tillbaka",
      "next": "Nästa",
      "upload": {
        "hint": "Dra och släpp en CSV-fil här, eller klicka för att bläddra",
        "csvOnly": "Endast CSV-filer",
        "browse": "Bläddra"
      },
      "mapping": {
        "headerRow": "Första raden är en rubrik",
        "nameColumn": "Namnkolumn",
        "emailColumn": "E-postkolumn",
        "phoneColumn": "Telefonkolumn",
        "notMapped": "— ej kopplad —",
        "column": "Kolumn",
        "preview": "Förhandsvisa"
      },
      "review": {
        "allValid": "Alla {{count}} kandidater är giltiga",
        "summary": "{{valid}} giltiga · {{invalid}} ogiltiga",
        "skipInvalid": "Hoppa över ogiltiga rader och importera {{count}} giltiga kandidater",
        "recheck": "Kontrollera igen",
        "import": "Importera {{count}} kandidater",
        "colName": "Namn",
        "colEmail": "E-post",
        "colPhone": "Telefon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Obligatoriskt",
        "emailInvalid": "Ogiltig e-postadress",
        "emailDuplicate": "Dubblerad e-post i denna fil",
        "phoneInvalid": "Landskod krävs (t.ex. +46…)"
      },
      "success": {
        "title": "Import klar",
        "body": "{{created}} importerade, {{conflict}} hade redan ansökningar (hoppades över), {{error}} misslyckades.",
        "done": "Klar"
      }
    },
    "screening": "Screening",
    "aiRanked": "AI-rankade",
    "emptyStage": "Inga ansökningar",
    "emptyTitle": "Inga kandidater ännu",
    "emptyDescription": "Lägg till din första kandidat för att börja granska ansökningar.",
    "emptySearchDescription": "Inga kandidater matchar din sökning.",
    "searchPlaceholder": "Sök efter namn, e-post eller telefon",
    "createDialog": {
      "title": "Lägg till ansökan",
      "name": "Fullständigt namn",
      "namePlaceholder": "t.ex. Anna Svensson",
      "email": "E-postadress",
      "emailPlaceholder": "t.ex. anna@example.com",
      "phoneNumber": "Telefonnummer",
      "phoneNumberPlaceholder": "t.ex. 070-123 45 67",
      "phoneCountryCode": "Landskod",
      "phoneCountryCodePlaceholder": "t.ex. +46",
      "submit": "Skapa ansökan"
    },
    "errors": {
      "conflict": "Denna kandidat har redan en ansökan för detta jobb."
    },
    "detail": {
      "title": "Ansökningsdetaljer",
      "tabs": {
        "application": "Ansökan",
        "profile": "Profil",
        "activity": "Aktivitet"
      },
      "stage": "Steg",
      "interviewLink": "Intervjulänk",
      "interviewStatus": "Intervjustatus",
      "copyLink": "Kopiera länk",
      "linkCopied": "Kopierad!",
      "noInterview": "Ingen intervjusession hittades",
      "noResults": {
        "title": "Intervjun ej slutförd",
        "description": "Kandidaten har inte genomfört intervjun ännu. Dela intervjulänken för att komma igång."
      },
      "inProgress": {
        "title": "Intervju pågår",
        "description": "Kandidaten har påbörjat intervjun. Resultaten visas här när den är klar."
      },
      "openInterview": "Öppna intervju",
      "commChannel": {
        "label": "Skicka via",
        "manual": "Manuellt",
        "email": "E-post",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Väntande",
        "in_progress": "Pågående",
        "completed": "Slutförd",
        "expired": "Utgången"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rader per sida",
    "rowsSelected": "{{count}} av {{total}} rad(er) valda.",
    "pageOf": "Sida {{page}} av {{total}}",
    "previous": "Föregående",
    "next": "Nästa"
  },
  "screening": {
    "title": "Screeningintervju",
    "aiDisclosure": "Du chattar med Sara, en AI-rekryteringsassistent",
    "selectLanguage": "Välj ditt föredragna språk",
    "selectLanguageDescription": "Intervjun genomförs på det språk du väljer",
    "startInterview": "Starta intervjun",
    "previewJobTitle": "Exempeljobb — Exempelföretag",
    "typeMessage": "Skriv ditt meddelande...",
    "send": "Skicka",
    "typing": "Sara skriver...",
    "submitInterview": "Skicka in intervju",
    "loading": "Laddar intervju...",
    "completed": {
      "title": "Intervjun slutförd",
      "submitted": "Intervjun har skickats in",
      "message": "Tack för att du slutförde intervjun för {{jobTitle}}. En rekryterare kommer att granska dina svar och höra av sig."
    },
    "expired": {
      "title": "Intervjun har löpt ut",
      "message": "Denna intervjulänk har löpt ut. Kontakta rekryteraren för en ny inbjudan."
    },
    "notFound": {
      "title": "Intervjun hittades inte",
      "message": "Denna intervjulänk är inte giltig. Kontrollera länken och försök igen."
    },
    "feedback": {
      "helpUsImprove": "Hjälp oss bli bättre",
      "teaser": "Hur var intervjuupplevelsen?",
      "overallPrompt": "Hur var den övergripande intervjuupplevelsen?",
      "disclaimer": "Vi vill gärna ha din feedback — den är anonym och påverkar inte din ansökan.",
      "prompt": "Hur gick intervjun?",
      "good": "Bra",
      "bad": "Dåligt",
      "notesLabel": "Ytterligare kommentarer?",
      "notesPlaceholder": "Berätta mer (valfritt)...",
      "skip": "Hoppa över",
      "submit": "Skicka feedback",
      "submitError": "Kunde inte skicka feedback. Försök igen."
    },
    "technicalIssue": {
      "buttonLabel": "Tekniskt problem?",
      "modalTitle": "Rapportera ett tekniskt problem",
      "modalDescription": "Beskriv problemet du upplevde. Din feedback skickas och intervjun startas om.",
      "notesLabel": "Vad gick fel?",
      "notesPlaceholder": "t.ex. Sidan frös och jag förlorade mitt framsteg...",
      "submitButton": "Skicka feedback och starta om",
      "submitError": "Kunde inte skicka. Försök igen.",
      "cancel": "Avbryt"
    },
    "error": {
      "title": "Något gick fel",
      "message": "Ett fel uppstod. Försök igen senare.",
      "sendFailed": "Kunde inte skicka meddelandet. Försök igen."
    },
    "languages": {
      "en": "Engelska",
      "da": "Danska",
      "sv": "Svenska",
      "de": "Tyska",
      "fr": "Franska",
      "es": "Spanska",
      "nl": "Nederländska",
      "pl": "Polska",
      "fi": "Finska",
      "ro": "Rumänska"
    },
    "landing": {
      "badge": "JOBBINTERVJU",
      "greeting": "Hej {{name}}! Vad kul att du är här. Det här är en inbjudan till en snabb online-screeningintervju med en AI för att lära känna dig. Ta den när du är redo.",
      "startChat": "Starta chattintervju",
      "startVoice": "Starta röstintervju",
      "or": "eller",
      "minutes": "{{count}} minuter",
      "questions": "{{count}} frågor"
    },
    "modality": {
      "title": "Välj intervjuformat",
      "description": "Välj hur du vill genomföra intervjun",
      "text": "Textintervju",
      "textDescription": "Skriv dina svar i en chatt",
      "voice": "Röstintervju",
      "voiceDescription": "Tala dina svar högt"
    },
    "deviceTest": {
      "title": "Kontrollera ditt ljud",
      "description": "Se till att din mikrofon och dina högtalare fungerar innan du börjar",
      "microphone": "Mikrofon",
      "speakers": "Högtalare",
      "testMicrophone": "Tillåt mikrofonåtkomst",
      "testSpeakers": "Spela testljud",
      "playAgain": "Spela igen",
      "requestingPermission": "Begär behörighet...",
      "microphoneDenied": "Mikrofonåtkomst nekades. Tillåt åtkomst i dina webbläsarinställningar.",
      "confirm": "Allt fungerar — starta intervjun"
    },
    "voice": {
      "title": "Röstintervju",
      "connecting": "Ansluter...",
      "recording": "Spelar in",
      "interviewInProgress": "Intervju pågår",
      "inProgress": "Intervju pågår — prata naturligt",
      "muted": "Din mikrofon är avstängd",
      "finished": "Intervjun klar — tack!",
      "alreadyInProgress": "Intervju pågår",
      "alreadyInProgressMessage": "Din röstintervju är för närvarande aktiv. Om du startar om den avbryts den pågående sessionen — gör det bara om du inte längre är ansluten.",
      "retryButton": "Starta om intervjun"
    }
  },
  "scoring": {
    "title": "Intervjuresultat",
    "pending": "Poängsättning pågår...",
    "processing": "AI utvärderar intervjun...",
    "failed": "Poängsättning misslyckades",
    "overallScore": "Totalpoäng",
    "overallScoreTooltip": "Poäng från 0–100 baserad på genomsnittet av alla bedömningsfrågepoäng, justerad för behörighet och jobbförväntningar.",
    "outcome": "Resultat",
    "outcomes": {
      "pass": "Godkänd",
      "fail": "Underkänd"
    },
    "summary": "Sammanfattning",
    "eligibility": "Behörighet",
    "niceToHave": "Meriterande",
    "expectations": "Jobbförväntningar",
    "assessment": "Bedömning",
    "information": "Informationsinsamling",
    "scoringAnchors": "Bedömningsankare",
    "candidateAnswer": "Kandidatens svar",
    "transcript": "Intervjutranskription",
    "viewInTranscript": "Visa i transkription",
    "copyPasteDetected": "Inklistrat svar",
    "copyPasteWarning": "Inklistring upptäckt i denna intervju",
    "copyPasteWarningTooltip": "Ett eller flera kandidatsvar klistrades in under intervjun. Det kan tyda på att kandidaten använde förberedda svar.",
    "verdicts": {
      "pass": "Godkänd",
      "fail": "Underkänd",
      "unsure": "Osäker",
      "review": "Behöver granskning"
    },
    "optional": "Valfri",
    "averageScore": "Genomsnittlig frågepoäng",
    "reasoning": "Motivering",
    "evidence": "Bevis",
    "backToJob": "Tillbaka till jobb",
    "overrideDialog": {
      "title": "Ändra poäng",
      "titleVerdict": "Ändra bedömning",
      "currentValue": "Nuvarande värde",
      "newValue": "Nytt värde",
      "reason": "Anledning till ändring",
      "reasonPlaceholder": "Förklara varför du ändrar denna poäng...",
      "reasonMinLength": "Minst {{min}} tecken krävs",
      "save": "Spara ändring",
      "cancel": "Avbryt",
      "error": "Kunde inte spara ändring. Försök igen."
    }
  },
  "workflows": {
    "title": "Arbetsflöde",
    "description": "Konfigurera stegen som ansökningar går igenom under din rekryteringsprocess.",
    "stages": {
      "title": "Pipelinesteg",
      "subtitle": "Dra för att ändra ordning. Ansökningar fortskrider genom dessa steg uppifrån och ner.",
      "system": "System",
      "manage": "Hantera steg",
      "addStage": "Lägg till steg",
      "editStage": "Redigera steg",
      "deleteStage": "Ta bort steg",
      "stageName": "Stegnamn",
      "stageNamePlaceholder": "t.ex. Telefonintervju",
      "stageColor": "Färg",
      "deleteConfirm": "Ta bort detta steg? Ansökningar i detta steg måste flyttas först.",
      "systemProtected": "Systemsteg kan inte tas bort",
      "hasApplications": "Detta steg har fortfarande ansökningar kopplade till sig"
    }
  },
  "communications": {
    "title": "Agentkommunikation",
    "languageSelector": "Språk",
    "tabs": {
      "sms": "SMS",
      "email": "E-post"
    },
    "emailSubject": "Ämne",
    "emailBody": "Brödtext",
    "variables": {
      "applicantName": "Sökandes namn",
      "jobTitle": "Jobbtitel",
      "jobEmployer": "Arbetsgivare",
      "jobLocation": "Jobbplats",
      "jobDescription": "Jobbeskrivning",
      "recruiterName": "Rekryterarens namn",
      "inviteUrl": "Inbjudningslänk"
    },
    "actions": {
      "edit": "Redigera",
      "save": "Spara ändringar",
      "reset": "Återställ till standard",
      "saved": "Mall sparad",
      "resetDone": "Återställd till standard"
    },
    "nodes": {
      "interviewIntro": "Intervjuintro",
      "interviewOutro": "Intervjuavslutning",
      "reminderToFinish": "Påminnelse att slutföra",
      "voiceAndChat": "Röst & Chatt",
      "emailsAndSms": "E-post & SMS",
      "comingSoon": "Kommer snart"
    },
    "characters": "{{count}}/{{max}} Tecken",
    "smsSegments": "{{count}} SMS-meddelanden ({{size}} tecken/segment)",
    "smsUnicodeWarning": "Detta meddelande innehåller emojis eller specialtecken som kräver Unicode-kodning, vilket minskar gränsen till 67 tecken per SMS.",
    "invite": {
      "title": "Kandidatinbjudan",
      "description": "Kandidater får detta när de läggs till i en jobbannons. E-postmeddelandet innehåller automatiskt en länk till intervjun.",
      "email": {
        "subject": "Du är inbjuden till din {{jobTitle}}-intervju! 🎯",
        "body": "<p>Hej {{applicantName}},</p><p>Du har blivit inbjuden att genomföra en snabb online-screeningintervju med vår AI-intervjuare för tjänsten <strong>{{jobTitle}}</strong> hos <strong>{{jobEmployer}}</strong>.</p><p>Det är ett enkelt sätt för oss att lära känna dig bättre — ta den när du är redo, var som helst. Det tar bara några minuter!</p><p><a href=\"{{inviteUrl}}\">Starta intervjun</a></p><p>Lycka till!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hej {{applicantName}}, jag är Sara, {{jobEmployer}}s AI-jobbassistent. Du har blivit inbjuden till en intervju för {{jobTitle}}. Det tar bara några minuter: {{inviteUrl}} (Inga svar)"
    },
    "reminder": {
      "title": "Intervjupåminnelse",
      "description": "Skickas automatiskt om en kandidat inte har påbörjat sin intervju inom 24 timmar efter inbjudan.",
      "email": {
        "subject": "Glöm inte din {{jobTitle}}-intervju",
        "body": "<p>Hej {{applicantName}},</p><p>Vi märkte att du inte har slutfört din AI-screeningintervju för tjänsten <strong>{{jobTitle}}</strong> hos <strong>{{jobEmployer}}</strong> ännu.</p><p>Det här är din chans att komma ett steg närmare — det tar bara några minuter, och att slutföra den ökar dina chanser att gå vidare till nästa steg.</p><p><a href=\"{{inviteUrl}}\">Slutför intervjun nu</a></p><p>Med vänliga hälsningar,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hej {{applicantName}}, bara en vänlig påminnelse — du har inte slutfört din {{jobTitle}}-intervju hos {{jobEmployer}} ännu. Det tar bara några minuter och hjälper dina chanser: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Skriv ditt e-postmeddelande...",
    "preview": {
      "outroSampleIntro": "Det var allt — tack för dina svar!",
      "outroSampleAnswer": "Inga problem, glad att kunna hjälpa till."
    },
    "intro": {
      "title": "Intervjuintro",
      "description": "Det exakta öppningsmeddelandet Sara säger för att hälsa kandidaten välkommen och fråga om de är redo att börja.",
      "scriptLabel": "Intromeddelande",
      "scriptPlaceholder": "Skriv det exakta öppningsmeddelandet Sara ska säga...",
      "defaultScript": "Hej! Jag är Sara, en AI-rekryteringsassistent för {{jobEmployer}}. Tack för att du tar dig tid att intervjua för tjänsten {{jobTitle}} — det tar bara några minuter. Är du redo att börja? 😊"
    },
    "outro": {
      "title": "Intervjuavslutning",
      "description": "Det exakta avslutningsmeddelandet Sara säger efter att alla frågor har besvarats.",
      "scriptLabel": "Avslutningsmeddelande",
      "scriptPlaceholder": "Skriv det exakta avslutningsmeddelandet Sara ska säga...",
      "defaultScript": "Det var allt — tack så mycket för din tid idag! En rekryterare kommer att granska dina svar och höra av sig. Lycka till! 🙂"
    }
  },
  "activity": {
    "title": "Aktivitet",
    "stageChange": "Flyttad från {{from}} till {{to}}",
    "interviewCompleted": "Slutförde screeningintervju",
    "scoreReceived": "Poäng mottagen: {{score}}/100",
    "applicationCreated": "Ansökan skapad",
    "noteAdded": "Anteckning tillagd",
    "bySystem": "System",
    "byAi": "AI",
    "empty": "Ingen aktivitet ännu",
    "emptyTitle": "Ingen aktivitet ännu",
    "emptyDescription": "Åtgärder och händelser för denna kandidat visas här."
  },
  "atsPush": {
    "title": "ATS-sändningsstatus",
    "retry": "Försök ATS-sändning igen",
    "retrying": "Försöker igen...",
    "rerunStep": "Kör detta steg igen",
    "rerunConfirm": "Detta steg har redan slutförts. Att köra det igen kan skapa dubblettdata i ditt ATS. Fortsätta?",
    "steps": {
      "transcript": "Transkription",
      "stage_move": "Stegflytt"
    },
    "status": {
      "completed": "Skickat",
      "failed": "Misslyckat",
      "pending": "Väntande"
    },
    "note": {
      "title": "AI-screeningintervju",
      "outcome": "Resultat",
      "score": "Poäng",
      "summary": "Sammanfattning",
      "eligibility": "Behörighet",
      "assessment": "Bedömning",
      "transcript": "Transkription",
      "candidate": "Kandidat",
      "interviewer": "Intervjuare",
      "pass": "Godkänd",
      "fail": "Underkänd",
      "review": "Granskning",
      "shortlist": "Urval",
      "reject": "Avslå",
      "viewProfile": "Visa kandidatprofil i Kiku",
      "transcriptAndAssessment": "TRANSKRIPTION OCH BEDÖMNING",
      "intro": "Intro",
      "eligibilityQuestions": "Behörighetsfrågor",
      "jobExpectations": "Jobbförväntningar",
      "assessmentQuestions": "Bedömningsfrågor",
      "outro": "Avslutning",
      "assessmentExplanation": "BEDÖMNINGSFÖRKLARING",
      "unsure": "Osäker",
      "viewInKiku": "VISA I KIKU FÖR MER DETALJER",
      "viewProfileLink": "Visa kandidatprofil i Kiku för att se förklaringar till poäng"
    }
  },
  "topbar": {
    "whatsNew": "Nyheter",
    "help": "Hjälp",
    "notifications": "Aviseringar"
  },
  "extension_candidate_banner": {
    "description": "Visa kandidatdetaljer.",
    "description_with_transcript": "Visa screeningtranskription & kandidatdetaljer.",
    "open_in_kiku": "Öppna",
    "dismiss": "Stäng"
  },
  "languages": {
    "en": "Engelska",
    "da": "Danska",
    "sv": "Svenska",
    "de": "Tyska",
    "fr": "Franska",
    "es": "Spanska",
    "nl": "Nederländska",
    "pl": "Polska",
    "fi": "Finska",
    "ro": "Rumänska"
  },
  "environmentBanner": {
    "development": "Utveckling",
    "test": "Test"
  },
  "notFound": {
    "title": "Sidan hittades inte",
    "description": "Sidan du letar efter finns inte eller har flyttats.",
    "goHome": "Tillbaka till Kiku"
  },
  "candidateProfile": {
    "title": "Kandidater",
    "cv": {
      "title": "CV / Meritförteckning",
      "upload": "Ladda upp CV",
      "replace": "Ersätt CV",
      "uploadDescription": "Ladda upp ett CV för att extrahera strukturerad profildata",
      "uploadLimit": "Max 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Visa original-CV",
      "status": {
        "pending": "I kö",
        "processing": "Bearbetar...",
        "done": "Bearbetat",
        "failed": "Bearbetning misslyckades"
      },
      "parsed": {
        "title": "Extraherad profil",
        "skills": "Kompetenser",
        "experience": "Erfarenhet",
        "education": "Utbildning",
        "languages": "Språk",
        "certifications": "Certifieringar",
        "present": "Nuvarande"
      },
      "errors": {
        "unsupportedType": "Filtypen stöds inte. Ladda upp en PDF, DOCX, PNG, JPG eller WEBP.",
        "tooLarge": "Filen är för stor. Maximal storlek är 10 MB.",
        "uploadFailed": "Kunde inte ladda upp CV. Försök igen."
      }
    }
  },
  "results": {
    "exportLabel": "Exportera",
    "exportCsv": "Exportera CSV",
    "csv": {
      "headers": {
        "candidateName": "Kandidatnamn",
        "email": "E-post",
        "role": "Roll",
        "stage": "Steg",
        "overallScore": "Totalpoäng",
        "outcome": "Resultat",
        "eligibility": "Behörighet",
        "expectations": "Förväntningar",
        "avgScore": "Snittpoäng",
        "interviewDate": "Intervjudatum",
        "status": "Status"
      }
    },
    "emptyTitle": "Inga resultat ännu",
    "emptyDescription": "Slutförda intervjuer visas här.",
    "columns": {
      "candidate": "Kandidat",
      "stage": "Steg",
      "status": "Status",
      "score": "Poäng",
      "outcome": "Resultat",
      "eligibility": "Behörighet",
      "expectations": "Förväntningar",
      "avgScore": "Snittpoäng",
      "interviewDate": "Intervjudatum",
      "question": "Fråga"
    },
    "statusLabels": {
      "pending": "Väntande",
      "processing": "Bearbetar",
      "completed": "Slutförd",
      "failed": "Misslyckad",
      "no_interview": "Ingen intervju"
    },
    "questionSections": {
      "eligibility": "Behörighet",
      "job_preview": "Förväntningar",
      "nice_to_have": "Meriterande",
      "assessment": "Bedömning",
      "information": "Information"
    },
    "fields": {
      "reasoning": "Motivering",
      "evidence": "Bevis",
      "response": "Svar",
      "avgScoreLabel": "Snittpoäng",
      "interviewDate": "Intervjudatum"
    }
  },
  "orgSettings": {
    "title": "Organisationsinställningar",
    "branding": {
      "title": "Varumärke",
      "logo": "Organisationslogotyp",
      "logoDescription": "Ladda upp en logotyp för att ersätta standardlogotypen i navigeringsfältet.",
      "uploadLogo": "Ladda upp logotyp",
      "removeLogo": "Ta bort logotyp",
      "logoHint": "PNG, JPG, WebP eller SVG. Max 2 MB.",
      "uploadSuccess": "Logotyp uppdaterad",
      "removeSuccess": "Logotyp borttagen",
      "uploadError": "Kunde inte ladda upp logotyp"
    },
    "timezone": {
      "title": "Tidszon",
      "description": "Ange standardtidszon för schemaläggning och visning av datum.",
      "label": "Tidszon",
      "saveSuccess": "Tidszon uppdaterad",
      "saveError": "Kunde inte uppdatera tidszon"
    },
    "save": "Spara ändringar"
  },
  "mcp": {
    "title": "MCP-integration",
    "subtitle": "Anslut AI-assistenter till Kiku via Model Context Protocol",
    "whatIsMcp": "Vad är MCP?",
    "whatIsMcpDescription": "Model Context Protocol (MCP) låter AI-assistenter som Claude, ChatGPT och andra verktyg interagera med Kiku direkt — lista jobb, visa kandidater och hantera din rekryteringspipeline genom naturligt språk.",
    "serverUrl": "Server-URL",
    "copyUrl": "Kopiera URL",
    "copied": "Kopierad!",
    "availableTools": "Tillgängliga verktyg",
    "toolListJobs": "Sök och lista jobbannonser med avdelningsnamn, filter för status, inställningsstatus och avdelning.",
    "toolGetJob": "Hämta alla detaljer om en specifik jobbannons, inklusive avdelningsnamn.",
    "toolCreateJob": "Skapa en ny jobbannons i en avdelning.",
    "toolAdvanceSetup": "Flytta ett jobb genom konfigurationsstegen (utkast, frågor_väntande, redo, aktiv).",
    "toolListApplications": "Lista ansökningar för ett jobb med fasnamn, poängstatus och resultat.",
    "toolGetInterviewResults": "Hämta AI-intervjuresultat för en ansökan — poäng, resultat och nedbrytning per fråga med motivering.",
    "toolGetPipelineSummary": "Hämta en pipeline-sammanfattning för ett jobb — antal kandidater per fas med godkänd/underkänd-totaler.",
    "setupTitle": "Installation med Claude Desktop",
    "setupStep1": "Öppna Claude Desktop",
    "setupStep2": "Klicka på Customize i vänster sidofält",
    "setupStep3": "Klicka på Connectors, sedan +-ikonen, sedan Add custom connector",
    "setupStep4": "Ange Name: Kiku och server-URL:en som visas ovan",
    "setupStep5": "Klicka Add — Claude kan nu använda dina Kiku-data"
  }
}
